import React from 'react'
import { useSelector } from 'react-redux'

import FreemiumMenu from './MenuSectionConfig/FreemiumMenuSection'
import PremiumMenu from './MenuSectionConfig/PremiumMenuSection'

const MenuSection = () => {
  const account = useSelector((state) => state.account.value)
  const sub = Number(account?.client_subscription ?? 0)
  return sub > 1 ? <PremiumMenu /> : <FreemiumMenu />
}

export default MenuSection
